import axios from 'axios';
import { getRudderstackAnonymousId } from '../utils/rudderstackAnonymousId';

/**
 * Get CSRF token from meta tag
 */
const getCsrfToken = () => {
  return document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
};

/**
 * Get brand ID from gon
 */
const getBrandId = () => {
  return window.gon?.current_brand || '';
};

const SignInService = {
  /**
   * Sign in a user via Devise session
   * @param {string} email - User's email address
   * @param {string} password - User's password
   * @returns {Promise<Object>} - The response data from the server
   * Response includes: success, user_id, pro_user, user_role, user object, etc.
   * Session cookie is automatically set by the browser from server response headers.
   */
  
  signIn: async (email, password, sourceType) => {
    const authenticity_token = getCsrfToken();

    const config = {
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': authenticity_token,
        'X-Requested-With': 'XMLHttpRequest'
      },
      withCredentials: true
    };

    const userData = {
      login_id: email,
      password: password,
      frontend_app: true
    };

    const anonymousId = getRudderstackAnonymousId();
    if (anonymousId) userData.anonymous_id = anonymousId;

    const queryParams = new URLSearchParams({ brand_id: getBrandId() });
    if (sourceType) queryParams.set('source_type', sourceType);
    const response = await axios.post(`/api/v5/sessions?${queryParams}`, userData, config);
    return response.data;
  }
};

export default SignInService;
